module.exports = __webpack_public_path__ + "img/PK.d5e627b0.png";